import { gql } from '@apollo/client';

export const GET_PATIENTS = gql`
  query GetPatientsPagination(
    $page: Int!
    $perPage: Int!
    $withCarePlan: Boolean
    $filter: GqlPatientFilter!
  ) {
    user {
      patient {
        patientPagination(
          page: $page
          perPage: $perPage
          withCarePlan: $withCarePlan
          filter: $filter
        ) {
          pageInfo {
            totalItems
            page
            perPage
            totalPages
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            name {
              firstName
              lastName
            }
            email
            gender
            phone
            photoUrl
            birthDate
            birthPlace {
              country
              city
              address
              zipcode
            }
            careTeams {
              id
              name
            }
            carePlans {
              items {
                title
                planDefinitionId
                patientId
                startDate
                engagement
                engagementRatio
                currentDay
                endDay
                status
                metrics {
                  metricDefinitionId
                  code
                  title
                  components {
                    __typename
                    code {
                      coding {
                        code
                        display
                        version
                        system
                      }
                      text
                    }
                    score
                    scoreType
                    ... on GqlNumericObservationComponent {
                      minValue
                      maxValue
                      quantityValue: value {
                        value
                        unit
                        system
                        code
                      }
                      scoreConfig {
                        scoreConditions {
                          id
                          score
                          values {
                            sign
                            value
                          }
                        }
                      }
                    }
                    ... on GqlScaleObservationComponent {
                      numberOfSteps
                      quantityValue: value {
                        value
                        unit
                        system
                        code
                      }
                      scoreConfig {
                        scoreConditions {
                          id
                          score
                          values {
                            sign
                            value
                          }
                        }
                      }
                    }
                    ... on GqlChoiceObservationComponent {
                      stringValue: value
                      scoreConfig {
                        scoreConditions {
                          id
                          score
                          title
                        }
                      }
                    }
                    ... on GqlQuestionnaireObservationComponent {
                      quantityValue: value {
                        value
                        unit
                        system
                        code
                      }
                      scoreDimensionMetadata {
                        dimensionId
                        dimensionName
                        isPrimaryDimension
                        isMainComponent
                      }
                      scoreConfig {
                        scoreConditions {
                          id
                          score
                          values {
                            sign
                            value
                          }
                        }
                      }
                    }
                  }
                  date
                }
              }
            }
            isMfaRequired
            isActive
            isSelfRegistered
            lastActivity
          }
        }
      }
    }
  }
`;

export const GET_PATIENTS_BASIC = gql`
  query GetPatientsPagination(
    $page: Int!
    $perPage: Int!
    $withCarePlan: Boolean
    $filter: GqlPatientFilter!
  ) {
    user {
      patient {
        patientPagination(
          page: $page
          perPage: $perPage
          withCarePlan: $withCarePlan
          filter: $filter
        ) {
          pageInfo {
            totalItems
            page
            perPage
            totalPages
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            name {
              firstName
              lastName
            }
            photoUrl
          }
        }
      }
    }
  }
`;
